import { Row } from 'react-table';

/**
 * Filters table rows by publisher and writer. The PublisherAndWriterFilter displays a label
 * comprised of one or both of `Publisher` and `Writer`. Both values are present on the current
 * filter value, and both must match for a row to pass the filter.
 * @param rows {Row<PerformanceTableItem>[]}
 * @param ids
 * @param filterValue
 */
function filterByPublisherAndWriter<D extends PublisherAndWriterItem>(
    rows: Row<D>[],
    ids: string[],
    filterValue: PublisherAndWriterFilterState,
): Row<D>[] {
    return rows.filter((row: Row<D>): boolean => {
        const conditions: boolean[] = [];

        if (filterValue?.publisher !== null) {
            conditions.push(row.original.publisher === filterValue.publisher);
        }

        if (filterValue?.writer !== null) {
            conditions.push(row.original.writer === filterValue.writer);
        }

        return conditions.every((condition: boolean): boolean => condition);
    });
}
// Let the table remove the filter if the value is empty.
filterByPublisherAndWriter.autoRemove = (
    filterValue: PublisherAndWriterFilterState,
): boolean => filterValue.writer === null && filterValue.publisher === null;

export { filterByPublisherAndWriter };
